import type { RecentFeedbackItem } from '../api/colleagueFeedbackApi';
import type { FeedbackEntry } from '../types';
import { getInitials, pickAvatarColor } from './avatarHelpers';
import { parseApiDateTime } from './parseApiDateTime';

export function mapRecentToFeedbackEntries(items: RecentFeedbackItem[]): FeedbackEntry[] {
  return items.map((i) => {
    const submittedAt = parseApiDateTime(i.submittedAt);
    return {
      id: i.id,
      targetId: i.targetId,
      targetName: i.targetName,
      targetInitials: getInitials(i.targetName),
      avatarColor: pickAvatarColor(i.targetName),
      ratings: i.ratings,
      feedback: i.feedback ?? '',
      submittedAt,
    };
  });
}
